/**
 * Frontend feature flags.
 *
 * Mirrors backend/feature_flags.py — keep the two in step. CRA inlines REACT_APP_* at build
 * time, so flipping this needs a rebuild, not just an env change.
 */

// Must accept exactly the same values as backend/feature_flags.py — if one half accepted "1" and
// the other didn't, setting it that way would enable Phase 2 on the server while the UI kept it
// hidden, which is precisely the drift this pair of flags exists to avoid.
const on = (v) => ['1', 'true', 'yes', 'on'].includes(String(v ?? '').trim().toLowerCase());

/**
 * Phase 2 identity + affordability verification: phone OTP, bank statements / Akahu open
 * banking, driver licence + selfie.
 *
 * OFF for GTM v1. The backend leaves those routes unmounted (ENABLE_PHASE2_VERIFICATION), so any
 * UI that calls them would fail — this flag keeps such UI hidden rather than broken. Notably the
 * phone-OTP tab on /register: with no Twilio configured and DEMO_MODE off, requesting a code
 * returns an error, so offering it is a dead end.
 */
export const ENABLE_PHASE2_VERIFICATION = on(process.env.REACT_APP_ENABLE_PHASE2_VERIFICATION);
